module.exports = __webpack_public_path__ + "da55a57521d136ba8ca1e597264fb825.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/scissors.png
// module id = 2431
// module chunks = 0